import { forwardRef } from 'react'

/**
 * Compass "North" indicator — circle with a vertical notch pointing up.
 * Designed to be rotated by the consumer so the notch points to true north.
 *
 * North-pointing compass indicator.  Uses `currentColor` for fill.
 */
export const CompassNorth = forwardRef(function CompassNorth(
  { className, width = '1em', height = '1em', style, ...rest },
  ref,
) {
  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 25 25"
      fill="currentColor"
      aria-hidden="true"
      className={className}
      style={style}
      {...rest}
    >
      <circle cx="12.5" cy="12.5" r="11" fill="none" stroke="currentColor" strokeWidth="1.5" />

      <circle cx="7.2" cy="7.2" r="0.7" />
      <circle cx="17.8" cy="7.2" r="0.7" />
      <circle cx="17.8" cy="17.8" r="0.7" />
      <circle cx="7.2" cy="17.8" r="0.7" />

      <line x1="3.8" y1="12.5" x2="5.8" y2="12.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />
      <line x1="19.2" y1="12.5" x2="21.2" y2="12.5" stroke="currentColor" strokeWidth="1.3" strokeLinecap="round" />

      <path d="M12.5 4.7 L9.9 11.9 Q12.5 8.6 15.1 11.9 Z" 
        stroke="currentColor" strokeWidth="1" strokeLinejoin="round"
      />
      <path
        d="M9.9 13.1 Q12.5 16 15.1 13.1 L12.5 20.3 Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinejoin="round"
      />
    </svg>
  )
})
